// extracted by mini-css-extract-plugin
export default {"imgError":"imgError_imgError__K0iwc"};